import * as docketPropTypes from "../docketPropTypes";
import appStyles from "../styles/appStyles";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { css } from "aphrodite/no-important";

export default class ExternalLink extends PureComponent {
	static propTypes = {
		aStyles: docketPropTypes.aphroditeStyles,
		children: PropTypes.node,
		className: PropTypes.string,
	};

	isExternalLink = (href) => {
		try {
			const linkUrl = new URL(href, window.location.origin);
			return linkUrl.hostname !== window.location.hostname;
		} catch (e) {
			return false;
		}
	};

	render() {
		const { children, className, aStyles, ...props } = this.props;
		let finalClassName = css(appStyles.baseFont, aStyles);
		if (className) {
			finalClassName += ` ${className}`;
		}

		const isExternal = this.isExternalLink(this.props?.href);
		const rel = isExternal ? "noopener noreferrer" : "noopener";

		return (
			<a className={finalClassName} {...props} rel={rel} target="_blank">
				{children}
			</a>
		);
	}
}
